import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { BaseService } from '../services';

/**
 * Installment API service — talks to the Node API (gatherco-api-v2).
 *
 * Routing: 'installment' is registered in base.service.ts NODE_JS_API_PATHS so all calls
 * here go to QUOTE_API_URL (= environment.nodeApiUrl), not the PHP API.
 */
@Injectable({ providedIn: 'root' })
export class InstallmentService {
  constructor(private baseService: BaseService) {}

  /**
   * Splits a pending installment row (or the implicit Final Payment balance) into two.
   * If after_sequence_index is null, the new row is appended before the Final Payment.
   */
  createInstallment(payload: {
    quote_id: number;
    amount: number;
    after_sequence_index: number | null;
  }): Observable<any> {
    return this.baseService.post('installment', payload).pipe(
      map<any, any>((response) => response.data),
      catchError((err) => throwError(() => err)),
    );
  }

  /**
   * Deletes a pending installment. Its amount is merged into the next pending row
   * (sequence_index + 1) or, if none, into the implicit Final Payment balance.
   */
  deleteInstallment(installmentId: number): Observable<any> {
    return this.baseService.delete(`installment/${installmentId}`).pipe(
      map<any, any>((response) => response.data),
      catchError((err) => throwError(() => err)),
    );
  }
}
